<template>
  <div class="pod-analytics-toolbar">
    <h1>{{ $t('routes.pod.analyticsDialog.title') }}</h1>
    <div class="pod-analytics-toolbar-wrapper">
      <PodAnalytics :pod-id="pod.id"/>
    </div>
  </div>
</template>

<script>
import PodAnalytics from '../../../../../routes/pods2/components/PodAnalytics.vue';

export default {
  name: 'AnalyticsToolbar',
  components: {
    PodAnalytics,
  },
  props: {
    pod: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.pod-analytics-toolbar {
  &-wrapper {
    padding: 20px;
    border-radius: 10px;
    background-color: rgb(var(--v-theme-tw-surface-accent));
  }
}
</style>
